import {
  Popover,
  PopoverBackdrop,
  PopoverButton,
  PopoverPanel,
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogDescription,
} from '@headlessui/react';
import {
  CheckCircleIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';
import React, { useState } from 'react';

const Rules = () => {
  const [isOpen, setIsOpen] = useState(true);
  const rules = [
    '<b>Turn on your microphone</b> so we can hear you clearly.',
    '<b>Find a quiet place</b> to avoid background noise or distractions.',
    "<b>You'll get 3 tries</b> to answer each question - use them wisely.",
    '<b>You have 3 minutes max per answer</b>, so stay focused.',
    '<b>Most importantly, do your best and good luck!</b> 🍀',
  ];

  return (
    <>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="cursor-pointer inline-flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900 dark:text-gray-100   focus:outline-none"
      >
        <InformationCircleIcon aria-hidden="true" className="size-5" />
        <span>Rules</span>
      </div>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className="relative z-50 rounded-lg"
      >
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4 rounded-lg bg-gray-900/50">
          <DialogPanel className="max-w-lg space-y-4 border bg-white p-12 rounded-2xl dark:bg-gray-800 text-gray-600 dark:text-gray-300">
            <DialogTitle className="font-bold">
              {' '}
              🙌 Before you start
            </DialogTitle>
            <DialogDescription>
              To make sure everything goes smoothly, please keep these in mind:
            </DialogDescription>
            <div className="flex flex-col gap-2">
              {rules.map((item, index) => (
                <div
                  key={index}
                  className="group relative flex gap-2 rounded-lg py-1"
                >
                  <div className="flex size-11 flex-none items-center justify-center rounded-lg">
                    <CheckCircleIcon aria-hidden="true" className="size-6 " />
                  </div>
                  <div>
                    <p
                      className="text-gray-600 dark:text-gray-300"
                      dangerouslySetInnerHTML={{ __html: item }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </>
  );

  // return (
  //   <Popover open={isOpen}>
  //     <PopoverButton
  //       onClick={() => setIsOpen(!isOpen)}
  //       className="inline-flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900 dark:text-gray-100 focus:outline-none"
  //     >
  //       <InformationCircleIcon aria-hidden="true" className="size-5" />
  //       <span>Rules</span>
  //     </PopoverButton>

  //     <PopoverBackdrop
  //       transition
  //       className="fixed z-10 inset-0 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in w-screen h-screen bg-gray-900 backdrop-blur-sm bg-opacity-50"
  //     />
  //     <PopoverPanel
  //       transition
  //       className="fixed left-1/2 top-1/2 z-10 flex w-screen max-w-max -translate-x-1/2 -translate-y-1/2 px-4 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
  //     >
  //       <div className="w-screen max-w-md flex-auto overflow-hidden rounded-3xl bg-gray-100 dark:bg-gray-900 text-sm/6 shadow-lg ring-1 ring-gray-500 dark:ring-gray-600">
  //         <div className="p-8 flex flex-col gap-4">
  //           <div className="flex flex-col gap-2">
  //             <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-200">
  //               🙌 Before you start
  //             </h2>
  //             <p className="text-sm text-gray-500 dark:text-gray-300">
  //               To make sure everything goes smoothly, please keep these in
  //               mind:
  //             </p>
  //           </div>
  //           <div className="flex flex-col gap-2">
  //             {rules.map((item, index) => (
  //               <div
  //                 key={index}
  //                 className="group relative flex gap-2 rounded-lg py-1"
  //               >
  //                 <div className="flex size-11 flex-none items-center justify-center rounded-lg">
  //                   <CheckCircleIcon
  //                     aria-hidden="true"
  //                     className="size-6 text-gray-600 dark:text-gray-300"
  //                   />
  //                 </div>
  //                 <div>
  //                   <p
  //                     className="text-gray-600 dark:text-gray-300"
  //                     dangerouslySetInnerHTML={{ __html: item }}
  //                   />
  //                 </div>
  //               </div>
  //             ))}
  //           </div>
  //         </div>
  //       </div>
  //     </PopoverPanel>
  //   </Popover>
  // );
};

export default Rules;
